import { useLocation, Navigate } from "react-router-dom";
import FullPage404 from "./../modules/aggregator/pages/FullPage404";

export const LayoutWrapper = ({ children }) => {
  const location = useLocation();

  const validPaths = [
    "/login",
    "/Dashboard",
    "/dashboard",
    "/withoutabha",
    "/detailsabha",
    "/machine-master",
    "/slot-management",
    "/patient-dialysis-list",
    "/ncd",
    "/sickle",
    "/pmndp",
    "/uwin",
    "/nikshay",
    "/aggregator",
    "/setting",
    "/myprofile",
    "/DueList",
    "/Duelist",
    "/uip-vaccination-center",
    "/create-vaccination-session",
    "/Underdevloped",
    "/Session",
    "/session",
    "/sessions",
    "/Sessions",
    "/uwin-registration",
    "/janani-beneficiaries",
    "/Daily-report",
    "/afhc/client-registration",
    "/e-opd"
  ];

  const isValid = validPaths.some(path =>
    location.pathname === path ||
    location.pathname.startsWith(path + "/")
  );

  // ❌ Invalid → show full 404 (no layout)
  if (!isValid) {
    return <FullPage404 />;
  }

  // 🔒 Authentication guard -> redirect to login if no token is present
  const token =
    localStorage.getItem("SKT_token") ||
    localStorage.getItem("NCD_token") ||
    localStorage.getItem("sickle_token") ||
    localStorage.getItem("PMNDP_token") ||
    localStorage.getItem("NIKSHAY_valid_user") ||
    localStorage.getItem("uwin_token") ||
    localStorage.getItem("JANANI_token") ||
    localStorage.getItem("RBSK_token") ||
    localStorage.getItem("e-OPD_token");

  if (location.pathname !== "/login" && !token) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Valid & Authenticated → render layout
  return children;
};

export default LayoutWrapper;